/**
 * zentrales Laden von Select2 mit Abhängigkeitschecks zu Login- und Manager-Bereich
 */

mp.select2 = {
    loading: false,

    init: function () {
        $(document).on('select2:open', function() {
            setTimeout(function() { $('.select2-search__field').get(0).focus(); }, 50);
        });

        if (mpSelect2OnReadyInits) {
            mp.select2.lazyLoadSelect2();
        }
    },
    lazyLoadSelect2: function () {
        if (mp.select2.loading === false && typeof $.fn.select2 === 'undefined') {
            mp.select2.loading = true;
            $.cachedScript($('#mpMainScript').attr('src').replace('mp.js', 'mpselect2.js')).done(function () {
                $.fn.select2.defaults.set('width', '100%'); // Resize-Thema
                $.cachedScript($('#mpMainScript').attr('src').replace('mp.js', 'i18n/' + mpData.currentLang + '-select2.js')).done(function () {
                    mp.select2.run();
                    if (typeof mplogin == 'object' && typeof mplogin.autocomplete == 'object') {
                        mplogin.autocomplete.run();
                    }
                    if (typeof mpmanager == 'object' && typeof mpmanager.form == 'object') {
                        mpmanager.form.init();
                    }
                    mp.select2.loading = false;
                });
            });
        } else if (mp.select2.loading === true) {
            // no double calls
        } else {
            mp.select2.run();
            if (typeof mplogin == 'object' && typeof mplogin.autocomplete == 'object') {
                mplogin.autocomplete.run();
            }
            if (typeof mpmanager == 'object' && typeof mpmanager.form == 'object') {
                mpmanager.form.init();
            }
        }
    },

    run: function () {
        // never call this directly!
        // all selectors must be present in observerLozadSelect2

        // STANDARD
        $('.mpSelect2:not(.done)').addClass('done').select2({
            language: (mpData.currentLang === 'zh' ? 'zh-CN' : mpData.currentLang),
            theme: 'bootstrap'
        });

        // with specific CSS-Styles
        $('.mpSelect2Class:not(.done)').addClass('done').select2({
            language: (mpData.currentLang === 'zh' ? 'zh-CN' : mpData.currentLang),
            theme: 'bootstrap',
            templateResult: function (data, container) {
                if (data.element) {
                    $(container).addClass($(data.element).attr('class'));
                }
                return data.text;
            }
        });

        // Brand-Search
        $('.mpSelect2BrandIds:not(.done)').addClass('done').select2({
            //data: mpSelect2BrandIds, // Achtung: das erzeugt dann sofort die <option>-Elemente; also kein Gewinn
            ajax: {
                url: '/blank.json', // Workaround: nur noch das ajax-Modul hat einen direkten Filter
                data: function () {
                    return null;
                },
                processResults: function (data, params) {
                    var res = [];
                    if (params.term && params.term !== '') {
                        res = $.grep(mpSelect2BrandIds, function (e) {
                            return e.text.toUpperCase().indexOf(params.term.toUpperCase()) >= 0;
                        });
                    } else {
                        res = mpSelect2BrandIds;
                    }
                    return {
                        results: res
                    };
                }
            },
            language: (mpData.currentLang === 'zh' ? 'zh-CN' : mpData.currentLang),
            theme: 'bootstrap'
        });

        // Model-Search
        $('.mpModelSearch:not(.done)').addClass('done').select2({
            language: (mpData.currentLang === 'zh' ? 'zh-CN' : mpData.currentLang),
            theme: 'bootstrap',
            minimumInputLength: 1,
            placeholder: mpData.translate['search'],
            ajax: {
                url: '/autocomplete/model-search',
                dataType: 'json',
                delay: 23,
                data: function (params) {
                    return {
                        term: params.term, // search term
                        page: params.page,
                        vendor: $(this).data('vendor-ident'),
                        calltype: $(this).data('calltype')
                    };
                },
                processResults: function (data, params) {
                    // Info: pages haben wir derzeit nicht
                    params.page = params.page || 1;

                    return {
                        results: data
                    };
                },
                cache: true
            }
        }).on('select2:select', function () {
            $(this).parents('.mpSelect2Flat').addClass('active');
            $(this).siblings('.input-group-append').show();

            if ($(this).hasClass('mpContentXhr')) {
                // der Trigger kommt durch .mpContentXhr
            } else {
                $(this).parents('form').submit();
            }
            return false;
        });
    }
}

$(document).ready(function () {
    mp.select2.init();
});
